import React from 'react';
import { useChatWidgetContext } from '@/widget/services/useChatWidgetContext';
import styles from './Header.module.scss';

function Header() {
  const { settings } = useChatWidgetContext();
  const { logoUrl } = settings;

  return (
    <div className={styles.container}>
      <div className={styles.logo}>
        <img src={logoUrl} alt="logo" />
      </div>
    </div>
  );
}

export default Header;
